// 📁 src/api/services/authService.js

export const getJToken = () =>
  localStorage.getItem("unified_auth_jtoken");

export const setJToken = (token) =>
  localStorage.setItem("unified_auth_jtoken", token);

export const getRefreshToken = () =>
  localStorage.getItem("refreshToken");

export const setRefreshToken = (token) =>
  localStorage.setItem("refreshToken", token);

export const getUserEmail = () =>
  localStorage.getItem("unified_auth_email");

export const getUserId = () =>
  localStorage.getItem("unified_auth_user_id");

export const getTenantId = () =>
  localStorage.getItem("unified_auth_tenant_id");

export const clearAuthData = () => {
  localStorage.removeItem("unified_auth_jtoken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("unified_auth_email");
  localStorage.removeItem("unified_auth_user_id");
  localStorage.removeItem("unified_auth_tenant_id");
};
